// -----------------------------------------------------------
// FloraIQ — Formatadores da tela de Qualidade
// -----------------------------------------------------------

export function formatDetectedAt(value: string): string {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
}

/** Nome do projeto a partir do id; issue sem projeto mostra "—". */
export function projectLabel(projectId: string, projectNames: Record<string, string>): string {
  if (!projectId) return "—";
  return projectNames[projectId] ?? `Projeto #${projectId}`;
}
